/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Components_Searchform_Error1Inputs */

const id_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const ms_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ralat: ${i?.message}`)
};

const da_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fejl: ${i?.message}`)
};

const de_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler: ${i?.message}`)
};

const en_us2_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const es_es2_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const es_mx2_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const fil_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const fr_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur : ${i?.message}`)
};

const it_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore: ${i?.message}`)
};

const hu_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hiba: ${i?.message}`)
};

const nl_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fout: ${i?.message}`)
};

const no_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Feil: ${i?.message}`)
};

const pl_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Błąd: ${i?.message}`)
};

const pt_br2_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const pt_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro: ${i?.message}`)
};

const ro_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eroare: ${i?.message}`)
};

const fi_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Virhe: ${i?.message}`)
};

const sv_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fel: ${i?.message}`)
};

const vi_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lỗi: ${i?.message}`)
};

const tr_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hata: ${i?.message}`)
};

const cs_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chyba: ${i?.message}`)
};

const bg_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Грешка: ${i?.message}`)
};

const ru_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка: ${i?.message}`)
};

const uk_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Помилка: ${i?.message}`)
};

const ar_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`خطأ: ${i?.message}`)
};

const hi_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`त्रुटि: ${i?.message}`)
};

const th_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาด: ${i?.message}`)
};

const ja_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エラー：${i?.message}`)
};

const zh_cn2_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const zh_hant1_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

const ko_components_searchform_error1 = /** @type {(inputs: Components_Searchform_Error1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Error: {message}" |
*
* @param {Components_Searchform_Error1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_searchform_error1 = /** @type {((inputs: Components_Searchform_Error1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Searchform_Error1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_searchform_error1(inputs)
	if (locale === "ms") return ms_components_searchform_error1(inputs)
	if (locale === "da") return da_components_searchform_error1(inputs)
	if (locale === "de") return de_components_searchform_error1(inputs)
	if (locale === "en-US") return en_us2_components_searchform_error1(inputs)
	if (locale === "es-ES") return es_es2_components_searchform_error1(inputs)
	if (locale === "es-MX") return es_mx2_components_searchform_error1(inputs)
	if (locale === "fil") return fil_components_searchform_error1(inputs)
	if (locale === "fr") return fr_components_searchform_error1(inputs)
	if (locale === "it") return it_components_searchform_error1(inputs)
	if (locale === "hu") return hu_components_searchform_error1(inputs)
	if (locale === "nl") return nl_components_searchform_error1(inputs)
	if (locale === "no") return no_components_searchform_error1(inputs)
	if (locale === "pl") return pl_components_searchform_error1(inputs)
	if (locale === "pt-BR") return pt_br2_components_searchform_error1(inputs)
	if (locale === "pt") return pt_components_searchform_error1(inputs)
	if (locale === "ro") return ro_components_searchform_error1(inputs)
	if (locale === "fi") return fi_components_searchform_error1(inputs)
	if (locale === "sv") return sv_components_searchform_error1(inputs)
	if (locale === "vi") return vi_components_searchform_error1(inputs)
	if (locale === "tr") return tr_components_searchform_error1(inputs)
	if (locale === "cs") return cs_components_searchform_error1(inputs)
	if (locale === "bg") return bg_components_searchform_error1(inputs)
	if (locale === "ru") return ru_components_searchform_error1(inputs)
	if (locale === "uk") return uk_components_searchform_error1(inputs)
	if (locale === "ar") return ar_components_searchform_error1(inputs)
	if (locale === "hi") return hi_components_searchform_error1(inputs)
	if (locale === "th") return th_components_searchform_error1(inputs)
	if (locale === "ja") return ja_components_searchform_error1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_searchform_error1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_searchform_error1(inputs)
	return ko_components_searchform_error1(inputs)
});
export { components_searchform_error1 as "components.searchForm.error" }